<template lang="pug">

transition(
  appear
)
  .icon-check
    svg(width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
      g
        circle(cx="12" cy="12" r="11" :fill="check? '#E15125': '#DADADA'")
        path(d="M6.60005 15.5C6.20005 15.1 6.20005 15.1 6.60005 15.5L8.30005 17.2C8.70005 17.6 9.30005 17.6 9.70005 17.2L17.8 9.09995C18.2 8.69995 18.2 8.09995 17.8 7.69995L17.1 6.99995C16.7 6.59995 16.1 6.59995 15.7 6.99995L9.70005 13C9.30005 13.4 8.70005 13.4 8.30005 13L7.60005 12.3C7.20005 11.9 6.60005 11.9 6.20005 12.3L5.60005 13C5.20005 13.4 5.20005 14 5.60005 14.4L8.40005 17.2C8.80005 17.6 8.80005 17.6 8.40005 17.2L6.60005 15.5Z" fill="white")



</template>

<script>
export default {
  name: 'icon-check',
  components: {},
  data() {
    return {}
  },
  props: {
    check: {
      required: true
    }
  },
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.icon-check
  width: 100%
  //overflow: hidden

</style>
